import styled from '@emotion/styled';
import {at} from '../../styles/utils';
import {breakpoints} from '../../styles/vars';

export const DefaultStyles = styled.div`
  font-size: 1.3em;
  line-height: 2em;
  padding-top: 5vh;
  min-height: 100vh;
  max-width: 1600px;
  margin: 0 auto;

  h1 {
    font-size: 2em;
    margin-bottom: 1em;
  }
  p {
    margin: 0 0 2em;
  }
  .links {
    display: flex;
    a {
      margin: 0em 1em 0em 0em;
    }
    [lang='ar'] {
      a {
        margin: 0em 0em 0em 1em;
      }
    }
  }
  ${at(breakpoints.laptop)} {
    font-size: 2.2em;
  }
  ${at(breakpoints.desktop)} {
    font-size: 3.2em;
    p {
      margin: 0 0 1em;
    }
  }
`;
